import React, { Fragment, useEffect, useState } from "react";
import { Popover, Spin } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import { getIndicatorColor, LINKS_PATH } from "./NextGenIndicators.utils";
import { handleError } from "../../modules/presence/sagas";

const BASE_API = process.env.REACT_APP_API + "/api";
const Circle = ({ color, borderColor = "black" }) => {
  return (
    <Fragment>
      <div
        style={{ width: 20, height: 20, backgroundColor: color, borderRadius: "50%", borderColor, borderWidth: 1 }}
      />
    </Fragment>
  );
};

const NextGenIndicators = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [circleColor, setCircleColor] = useState("white");
  const fetchIndicatorsStatus = async () => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${BASE_API}/nextgen/indicatorsstatus`, {
        headers: {
          Authorization: token
        }
      });
      setData(result.data);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };
  useEffect(() => {
    fetchIndicatorsStatus();
  }, []);
  useEffect(() => {
    setCircleColor(getIndicatorColor(data));
  }, [data]);

  const hoverContent = (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {data
        .filter((_, index) => LINKS_PATH[index])
        .map((item, index) => (
          <Link
            key={index}
            to={{ pathname: LINKS_PATH[index].link }}
            // style={{ pointerEvents: item.count === 0 ? "none" : "auto" }}
            style={{ pointerEvents: "auto" }}
          >
            <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: 10 }}>
              <Circle color={item.color} />
              <div style={{ marginLeft: 10 }}>{`${item.label} ${item.count > 0 ? `(${item.count})` : ""}`}</div>
            </div>
          </Link>
        ))}
    </div>
  );
  if (isLoading) {
    return <Spin />;
  }

  return (
    <Fragment>
      <Popover content={hoverContent} title="Indicateurs nextgen">
        <div style={{ display: "flex" }}>
          <Circle color={circleColor} />
        </div>
      </Popover>
    </Fragment>
  );
};

export default NextGenIndicators;



// WEBPACK FOOTER //
// src/components/nextgenindicators/NextGenIndicators.js